import { gql } from '@apollo/client';

export const FR_SERVICE_REASON_FIELDS = gql`
    fragment fr_ServiceReasonFields on ServiceReason {
        ServiceReasonId
        Name
        sv_name: Name(LangCode: SV)
        en_name: Name(LangCode: EN)
        no_name: Name(LangCode: NO)
    }
`;
